/* Eywa | Customize Search to include tags & other terms | Apr 12, 2017 */

$(document).ready(function(){
	$('#search-home').submit(function(){
		var searchtext = $('input[name="q"]').val();
		/* $('#q').val("product_type:*"+searchtext+"* OR title:*"+searchtext+"*"); */
      	$('#q').val(searchtext+"*");
    });
	$('#search-list').submit(function(){
		var searchtext = $('#q2').val();
		/* $('#q').val("product_type:*"+searchtext+"* OR title:*"+searchtext+"*"); */
        $('#q2').val(searchtext+"*");
    });  
});